var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"label-tag",class:{ sm: _vm.small, [_vm.variant]: _vm.variant },style:(!this.variant ? _vm.labelStyles : null)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }